import React, { useEffect } from "react";
import { Col } from "antd";
import { useNavigate } from "react-router-dom";
import { appTitle } from "./common/GeneralConfigurations";
import AdnLogo from "../assets/images/logo_sem_adentis.png";
import { AppRoutes } from "../AppRoutes";

const NotFoundPage = () => {
    useEffect(() => {
        document.title = `${appTitle} - Page Not Found`;
    }, []);

    const navigate = useNavigate();

    return (
        <div id="main">
            <div
                className="text-center"
                style={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "75px",
                }}
            >
                <Col className="important d-none d-sm-block">
                    <img
                        src={AdnLogo}
                        fluid
                        className="full"
                        style={{ cursor: "pointer" }}
                        height="260"
                        alt="logo"
                        onClick={() => navigate(AppRoutes.home.path)}
                    />
                </Col>
                <h1>Page not found</h1>
                <h6>The page you were looking for doesn't exist.</h6>
            </div>
        </div>
    );
};

export default NotFoundPage;
